import { render, staticRenderFns } from "./imageLibrary.vue?vue&type=template&id=05468de8&scoped=true&"
import script from "./imageLibrary.vue?vue&type=script&lang=js&"
export * from "./imageLibrary.vue?vue&type=script&lang=js&"
import style0 from "./imageLibrary.vue?vue&type=style&index=0&id=05468de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05468de8",
  null
  
)

export default component.exports